"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { AddPetDialog } from "@/components/AddPetDialog"

export default function PetPage() {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Моите любимци</h1>

      <div className="text-center py-12 space-y-4">
        <p className="text-gray-500">Все още нямате добавени любимци</p>
        <Button className="bg-[#00A0E3] hover:bg-[#0090D3] text-white" onClick={() => setDialogOpen(true)}>
          ДОБАВИ НОВ ЛЮБИМЕЦ
        </Button>
      </div>

      <AddPetDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </div>
  )
}

